export function formatHHMMSS(totalSeconds: number): string {
  const seconds = Math.max(Math.floor(Number(totalSeconds) || 0), 0);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return [hours, minutes, secs].map((n) => String(n).padStart(2, "0")).join(":");
}

export function formatMMSS(totalSeconds: number): string {
  const seconds = Math.max(Math.floor(Number(totalSeconds) || 0), 0);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return [minutes, secs].map((n) => String(n).padStart(2, "0")).join(":");
}
